<div class="pageWrapper supplier-oms">
  <div class="formsDetails rfq">
    <section class="oms-upper-section">
      <span routerLink="/oms/orders">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
        </svg>
      </span>

      <h3 class="page-title">Order Management</h3>
    </section>

    <div class="lst_dtl">
      <div>
        <div>
          <div class="rfq_lst_dtl">
            <mat-card class="rfq-card">
              <div class="oms-card-top flex">
                <div class="flex">
                  <span class="oms-po-id">P.O ID : </span>
                  <span class="po-id">{{ orderDetail?.poId }}</span>
                  <span class="po-template">{{ orderDetail?.rfqTemplateType }}</span>
                </div>
                <div class="flex">
                  <span class="oms-status {{ orderDetail?.customerEdp?.edpStatus }}">{{
                    getEdpStatusLabel(orderDetail?.customerEdp?.edpStatus)
                  }}</span>
                </div>
              </div>
              <mat-card-header>
                <div class="rfq-title-expiry">
                  <mat-card-title> {{ orderDetail?.projectName }}</mat-card-title>
                  <mat-card-subtitle>
                    <span class="small-font">Order Date : </span>
                    <span class="light-font"> {{ orderDetail?.orderDate | date: "MMM d, y" }}</span>
                  </mat-card-subtitle>
                </div>
                <div class="rfq-capabilities">
                  <h5 class="rfq-category cate">Category</h5>
                  <ng-container *ngFor="let cat of (orderDetail?.categories | categoryFormatter: 2).display">
                    <span class="capability" [matTooltip]="(orderDetail?.categories | categoryFormatter: 2).tooltip">
                      {{ cat }}
                    </span>
                  </ng-container>
                </div>
                <div class="rfq-capabilities">
                  <h5 class="rfq-category cate">Total Quantity</h5>
                  <h5 class="rfq-category">{{ orderDetail?.totalQuantity }}</h5>
                </div>
              </mat-card-header>
              <div class="flex detail_box">
                <div class="rfq-capabilities">
                  <h5 class="rfq-category cate">Due Date</h5>
                  <h5 class="rfq-category due-date">{{ orderDetail?.dueDate | date: "MMM d, y" }}</h5>
                </div>

                <div class="rfq-capabilities">
                  <h5 class="rfq-category cate">Start Date</h5>
                  <h5 class="rfq-category due-date">{{ orderDetail?.startDate | date: "MMM d, y" }}</h5>
                </div>

                <div class="rfq-capabilities">
                  <h5 class="rfq-category cate">End Date</h5>
                  <h5 class="rfq-category due-date">{{ orderDetail?.endDate | date: "MMM d, y" }}</h5>
                </div>

                <!-- <div class="rfq-capabilities">
                  <span class="view_all"> View All Chat </span>
                </div> -->
              </div>
            </mat-card>
          </div>
        </div>
      </div>

      <mat-tab-group>
        <mat-tab label="Milestones" *ngIf="false">
          <div class="heading">
            <div class="column">
              <span> Milestones </span>
            </div>
            <div class="column"><span> Planned Dates </span></div>
            <div class="column"><span> Actual Dates </span></div>
          </div>

          <mat-accordion *ngFor="let mile of orderDetail?.customerEdp?.customerMilestones; index as index">
            <mat-expansion-panel>
              <mat-expansion-panel-header #panelH>
                <div class="flex list_table">
                  <div class="column">
                    <div class="flex mile_label">
                      <mat-checkbox
                        class="example-margin"
                        (change)="checkMilestones($event.checked, index, mile.id)"
                        [checked]="getCompletedStatus(mile) === 'Completed'"
                        disabled
                      >
                      </mat-checkbox>
                      <div class="file_name">{{ mile.milestoneName }}</div>
                    </div>
                    <span class="status">{{ getCompletedStatus(mile) }}</span>
                  </div>

                  <div class="column">
                    <div class="date">
                      <span class="date_label">Start Date</span>
                      <mat-form-field appearance="outline">
                        <input
                          id="modules_rfqmodule_rfqquote_28"
                          matInput
                          [matDatepicker]="picker1"
                          placeholder="MM/DD/YYYY"
                          [(ngModel)]="mile.startDate"
                          [min]="yesterday"
                          (dateChange)="selectedDate($event)"
                          (click)="openDatePicker(picker1)"
                          [value]="yesterday"
                          [disabled]="true"
                        />
                        <mat-datepicker #picker1></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div class="date">
                      <span class="date_label">End Date</span>
                      <mat-form-field appearance="outline">
                        <input
                          id="modules_rfqmodule_rfqquote_28"
                          matInput
                          [matDatepicker]="picker2"
                          placeholder="MM/DD/YYYY"
                          [(ngModel)]="mile.endDate"
                          (click)="openDatePicker(picker2)"
                          [min]="yesterday"
                          (dateChange)="selectedDate($event)"
                          [disabled]="true"
                        />
                        <mat-datepicker #picker2></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="column">
                    <div class="date">
                      <span class="date_label">Start Date</span>
                      <mat-form-field appearance="outline">
                        <input
                          id="modules_rfqmodule_rfqquote_28"
                          matInput
                          [matDatepicker]="picker3"
                          placeholder="MM/DD/YYYY"
                          [(ngModel)]="mile.actualStartDate"
                          (click)="openDatePicker(picker3)"
                          [min]="yesterday"
                          (dateChange)="selectedDate($event)"
                          [disabled]="true"
                        />
                        <mat-datepicker #picker3></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div class="date">
                      <span class="date_label">End Date</span>
                      <mat-form-field appearance="outline">
                        <input
                          id="modules_rfqmodule_rfqquote_28"
                          matInput
                          [matDatepicker]="picker4"
                          placeholder="MM/DD/YYYY"
                          [(ngModel)]="mile.actualEndDate"
                          (click)="openDatePicker(picker4)"
                          [min]="yesterday"
                          (dateChange)="selectedDate($event)"
                          [disabled]="true"
                        />
                        <mat-datepicker #picker4></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex btn_box column on_time">
                    <div *ngIf="mile.actualEndDate">
                      <ng-container *ngIf="mile.onTime; else delayed">
                        <span class="onTime"> On Time </span>
                      </ng-container>
                      <ng-template #delayed><span class="delayed">Delayed</span></ng-template>
                    </div>
                  </div>

                  <div class="flex btn_box column">
                    <div
                      class="flex comment_box btn_dtl feedback"
                      (click)="viewCommentSection($event, mile?.id, mile.milestoneName, entityType.MILESTONE)"
                    >
                      <span class="comment_icon">
                        <lucide-icon name="message-square" class="lucid-icon"></lucide-icon>
                      </span>
                      <span [ngClass]="{ active: !getCommentStatus(mile?.id) }"></span>
                    </div>

                  </div>
                </div>
              </mat-expansion-panel-header>
            </mat-expansion-panel>
          </mat-accordion>
        </mat-tab>
        <mat-tab label="Invoice">
          <app-invoice-details></app-invoice-details>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>

<div class="commentbox-overlayDrop" *ngIf="commentPanelActive" (click)="closeCommentSection($event)"></div>
<div class="commentbox-layout-rightpanel" [ngClass]="{ 'commentbox-layout-rightpanel-active': commentPanelActive }">
  <app-comment-sidenav
    [baseUrl]="baseUrl"
    [metaData]="metaData"
    [entityId]="entityId"
    [milestoneName]="milestoneName"
    (childClick)="closeCommentSection($event)"
  ></app-comment-sidenav>
</div>
